module.exports = __webpack_public_path__ + "img/category-6.b13a88f4.svg";